import Vue from "vue";
import FilterGroup from "../components/reports/filter-group.vue";
import OrdersFilter from "./filter/orders";
import QuotationFilter from "./filter/quotations";
import CampaignFilter from "./filter/campaign_interaction";
import CLVFilter from "./filter/clv";
import EventsFilter from "./filter/custom_events";
import BirthdateFilter from "./filter/birthdate";
import PurchasedProduct from "./filter/purchased_product";
import CommunicationChannels from "./filter/communication_channels.vue";
import QuotationsAmount from "./filter/quotations-amount.vue";
import FormResponses from "./filter/form_responses.vue";
import FilterPeriod from "../components/reports/filters/period";
import FilterBranch from "../components/reports/filters/branch";
import FilterMinMax from "../components/reports/filters/min-max";
import FilterSelect from "../components/reports/filters/select";
import FilterCheckbox from "../components/reports/filters/checkbox";
import FilterTextfield from "../components/reports/filters/textfield";

Vue.component("orders", OrdersFilter);
Vue.component("quotations", QuotationFilter);
Vue.component("quotationsAmount", QuotationsAmount);
Vue.component("clv", CLVFilter);
Vue.component("customEvents", EventsFilter);
Vue.component("birthdate", BirthdateFilter);
Vue.component("purchasedProduct", PurchasedProduct);
Vue.component("formResponses", FormResponses);
Vue.component("campaignInteraction", CampaignFilter);
Vue.component("period", FilterPeriod);
Vue.component("branch", FilterBranch);
Vue.component("min-max", FilterMinMax);
Vue.component("selectbox", FilterSelect);
Vue.component("checkbox", FilterCheckbox);
Vue.component("textfield", FilterTextfield);

FilterGroup.components["campaignInteraction"] = CampaignFilter;
FilterGroup.components["orders"] = OrdersFilter;
FilterGroup.components["quotations"] = QuotationFilter;
FilterGroup.components["quotationsAmount"] = QuotationsAmount;
FilterGroup.components["clv"] = CLVFilter;
FilterGroup.components["customEvents"] = EventsFilter;
FilterGroup.components["birthdate"] = BirthdateFilter;
FilterGroup.components["purchasedProduct"] = PurchasedProduct;
FilterGroup.components["formResponses"] = FormResponses;
FilterGroup.components["communicationChannels"] = CommunicationChannels;

export { FilterGroup, CommunicationChannels };
